import { render } from "./EditDemographics.vue?vue&type=template&id=542df78e&ts=true"
import script from "./EditDemographics.vue?vue&type=script&lang=ts"
export * from "./EditDemographics.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__